<template>
  <BryntumNumberField :value="internalValue" :min="min" :max="max" :readOnly="false" :width="width"
    @action="e => emitValue(e.value)">
  </BryntumNumberField>
</template>


<script>
import { BryntumNumberField } from '@bryntum/schedulerpro-vue';

export default {
  name: "BNumberField",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    value: [Number, String],
    singleline: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    rules: Array,
    stepSize: String,
    min: Number,
    max: Number,
    adjustWidthToContent: Boolean,
  },
  components: {
    BryntumNumberField,
  },

  data() {
    return {
      internalValue: this.value,
    };
  },

  methods: {
    emitValue(value) {
      this.internalValue = value;
      //console.log("emitValue", value);
      this.$emit("input", value);
    },
  },

  computed: {
    width() {
      //console.log("width", width, (this.internalValue ?? 0).toString());
      if (this.adjustWidthToContent) {
        var width = ((this.internalValue ?? 0).toString().length * 12) + 8;
        //console.log("width", width);
        return width;
      }
      else {
        return "100%";
      }
    },
  },

  watch: {
    /*
    value: {
      handler: function (value) {
        //console.log("watch value", value);
      },
      immediate: true,
    },
    */
  },
};
</script>


<style lang='scss'>
/*
.b-numberfield {
  width: 100%;
}
  */
.b-numberfield {
  font-size: 12px;
}

.b-numberfield input {
  padding: 2px 4px;
}

.b-numberfield .b-spintrigger {
  font-size: 10px;
  padding-inline: 0 4px !important;
}

.b-icon .b-spin-up {
  margin-top: -1px;
}

.b-icon .b-spin-down {
  margin-bottom: -1px;
}
</style>
